export const KeywordSearchApi = Symbol.for('KeywordSearchApi');
